import styled from 'styled-components';

const SErrorBoundary = styled.div`
  display: flex;
  flex-direction: column;
  padding: 30px 0;

  div {
    text-align: center;
  }

  svg {
    margin-bottom: 20px;
  }

  &.xs {
    flex-direction: row;
    padding: 15px 0;

    svg {
      margin-bottom: 0;
      margin-right: 10px;
    }

    div {
      text-align: left;
    }
  }

  details {
    padding: 5px 0;
  }
`;

export default SErrorBoundary;
